module.exports = __webpack_public_path__ + "img/9baad82.svg";